<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-book-open"></i></div>
      <div>
        Matières
        <div class="page-title-subheading">Matières enseignées</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row mb-3">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle matière
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Activer</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Désactiver</button>
                                <button class="btn btn-info btn-sm btn-label waves-effect waves-light  me-3" (click)="addR(addRContent)">Ajouter une rubrique</button>
                               <button *ngIf="data.length!=0" (click)="getPdf()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Exporter en PDF</button>
                    </div>
                                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Rechercher..." [(ngModel)]="search_text">
                    </div>
</div>
                        <p>{{data!.length}} élément(s)</p>
                        <div class="">
                        <table class="table table-striped table-hover table-borderless table-sm" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Libellé</th>
                                    <th>Coefficient</th>
                                    <th>Couleur</th>
                                    <th>Rubriques</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'courses' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>
                                      <span>{{d.name}}</span>
                                      <br>
                                      <span *ngIf="d.is_special" class="badge bg-primary">Spécialité</span>

                                    </td>
                                    <td>{{d.coefficient}}</td>
                                    <td>
                                        <div style="height: 20px; width: 20px; background-color: {{d.color}};"></div>
                                    </td>
                                    <td>
                                      <span *ngIf="d.subcourses.length==0">Pas de rubriques</span>
                                      <ul *ngIf="d.subcourses.length!=0">
                                        <li *ngFor="let s of d.subcourses" class="d-flex justify-content-between">
                                          <span  class="h6 me-2">{{s.name}}</span>
                                          <span>
                                            <i (click)="editR(editRContent,s)" class="fa fa-edit text-warning pointer mx-1"></i>
                                            <i (click)="deleteR(s)" class="fa fa-trash text-danger pointer"></i>
                                          </span>

                                        </li>
                                      </ul>
                                    </td>
                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Actif</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Bloqué</span>
                                      
                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                          class="my-pagination"
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une matière</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Coeficient <span class="text-danger ml-2">(*)</span></label>
                <input type="number" name="coefficient" min="1" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Couleur <span class="text-danger ml-2">(*)</span></label>
                <input type="color" name="color" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <div class="form-check">
                    <label class="form-check-label me-5" for="flexCheckDefault">
                        S'agit il d'une matière spéciale
                      </label>
                    <input class="form-check-input" type="checkbox" [value]="0" ngModel name="is_special" id="flexCheckDefault">
                   
                  </div>
            </div>
         
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
<ng-template #addRContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="storeR(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une rubrique</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel required>
            </div>
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier une matière</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control"  [(ngModel)]="selected_data.name">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Coeficient <span class="text-danger ml-2">(*)</span></label>
                <input type="number" name="coefficient" min="1" class="form-control"  [(ngModel)]="selected_data.coefficient">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Couleur <span class="text-danger ml-2">(*)</span></label>
                <input type="color" name="color" class="form-control" [(ngModel)]="selected_data.color" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <div class="form-check">
                    <label class="form-check-label me-5" for="flexCheckDefault">
                        S'agit il d'une matière spéciale
                      </label>
                    <input class="form-check-input" type="checkbox" [value]="0"  [(ngModel)]="selected_data.is_special" name="is_special" id="flexCheckDefault">
                   
                  </div>
            </div>

           
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
  <ng-template #editRContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="updateR(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier une rubrique</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control"  [(ngModel)]="selected_data.name">
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <table class="table table-borderless align-middle mb-0">
                <tbody>
                 
                </tbody>
            </table>
        </div>
      </div>
</ng-template>

<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>
